import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ServiceInsightsPhotoObject } from 'src/app/features/service-insights/types/service-insights-export-photo.types';
import { ServiceInsightsphotoObjectDefault } from '../export-photo-constants';

@Component({
    selector: 'service-insights-photo-carousel',
    templateUrl: './service-insights-photo-carousel.component.html',
    styleUrls: ['./service-insights-photo-carousel.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('.4s ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('.4s ease-in', style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
/**
 * Component that renders a single photo view within the Service Insights photo gallery.
 * It allows navigation between photos, closing the view, and downloading the current photo.
 */
export class ServiceInsightsPhotoCarouselComponent {
  @Input() serviceInsightsPhotoObject: ServiceInsightsPhotoObject =
    ServiceInsightsphotoObjectDefault;
  @Input() currentSlideIndex: number = 0;
  @Output() photoSelected = new EventEmitter<number>(); // The currently selected photo index to enforce styling on the thumbnail gallery

  showNextSlide(): void {
    this.currentSlideIndex =
      (this.currentSlideIndex + 1) %
      this.serviceInsightsPhotoObject.photoInfo.length;
    this.photoSelected.emit(this.currentSlideIndex);
  }

  showPrevSlide(): void {
    this.currentSlideIndex =
      (this.currentSlideIndex -
        1 +
        this.serviceInsightsPhotoObject.photoInfo.length) %
      this.serviceInsightsPhotoObject.photoInfo.length;
    this.photoSelected.emit(this.currentSlideIndex);
  }
}
